<template>
  <modalTutorial ref="tutorialModal" title="How to use buckets">
    <div>
        <div class="row">
          <div class="col-md-12">
            <strong>
              Buckets are used to group common annotations together.
            </strong>
            <p>
              For instance if you're collecting interview text for podcast, you should add 3 buckets. One to denote content, one to denote filler content and one for the outro.
            </p>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-6">
            <strong>
              Create a bucket from the sidebar
            </strong>
            <p>
              Choose a color for your bucket and a title.
            </p>
            <p>
              You can place the '|' character to shorten the title. For instance, 'Filler | non-important content' will show up as Filler in the dashboard and elsewhere.
            </p>
          </div>
          <div class="col-md-6">
            <img src="/tutorials/bucket/bucket2.jpg" class="img-fluid">
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <p>
            This is how the previous example would look like:
            </p>
          </div>
          <div class="col-md-6">
            <img src="/tutorials/bucket/bucket1.jpg" class="img-fluid">
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <strong>
              Using the bucket
            </strong>
            <p>
              After creating the bucket, it is available inside the highligher.
            </p>
            <p>
              From now on, whenever you highlight text, the highlighter will show the bucket as an option.
            </p>
            <p>
              You can also change the bucket from the dashboard.
            </p>
          </div>
        </div>
      <div class="footer">
        <a
          class="btn btn-lg btn-secondary"
          @click="$refs.tutorialModal.hide()"
        >
          Close
        </a>
      </div>
    </div>
  </modalTutorial>
</template>

<script>
import modalTutorial from "@/components/modals/modal-tutorial.vue";
export default {
  components : {
    modalTutorial
  },
  methods : {
    show : function() {
      this.$refs.tutorialModal.show();
    }
  }
}
</script>

<style lang="scss">
#modal-tutorial___BV_modal_content_ {

  .img-fluid {
    margin:$md-base-size 0;
    border-radius: 5px;
  }
}
</style>